import React from "react";
import styles from "./LoginLink.module.scss";
import { getLoginUrl } from "@utils/getLoginUrl";
import assetLoader from "@utils/internalImageLoder";
import ImageAtom from "@components/atoms/Image";
import { LoginSdkConfig } from '@enums/LoginSdkConfig';
import { handleLoginFlow } from "@utils/loginFlowHandler";

type LoginLinkProps = {
  isMobile: boolean;
};

const LoginLink = ({ isMobile }: LoginLinkProps) => {
  const handleLogin = async () => {
    const currentUrl = window.location.href;
    const loginUrl = getLoginUrl(currentUrl);
    await handleLoginFlow(getLoginUrl(loginUrl), LoginSdkConfig.AD_PRICE);
  };
  return (
    <div onClick={handleLogin} className={styles.loginLink}>
      {isMobile ? (
        <span>Login</span>
      ) : (
        <span>Login to check ACKO Drive price</span>
      )}
      <ImageAtom
        src={`${assetLoader()}/icons/chevron-right.svg`}
        alt="Arrow"
        width={24}
        height={24}
      />
    </div>
  );
};

export default LoginLink;
